import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState, RootThunk, RootThunkApi } from '../../../../app/store'
import * as service from '../../../../services/fieldSetting'
import { sendAsync } from '../../../../app/applicationSlice'

export const getFieldSettingList = createAsyncThunk<
  any,
  service.getConfigParams,
  RootThunkApi
>('fieldSetting/getFieldSettingList', async (params, api) => {
  return sendAsync(service.getFieldSettingList(params), api)
})

export const saveFieldSettingList = createAsyncThunk<
  any,
  service.SaveFieldSettingParams,
  RootThunkApi
>('fieldSetting/saveFieldSettingList', async (body, api) => {
  return sendAsync(service.saveFieldSetting(body), api)
})


export const restoreDefaultSetting = createAsyncThunk<
  any,
  service.getConfigParams,
  RootThunkApi
>('fieldSetting/restoreDefaultSetting', async (params, api) => {
  return sendAsync(service.restoreDefaultSetting(params), api)
})
